import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=1bf1e828&"
import script from "./Addresses.vue?vue&type=script&lang=js&"
export * from "./Addresses.vue?vue&type=script&lang=js&"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=1bf1e828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports